export default "__VITE_ASSET__57f20178__"